export type Revenue = {
  productId: string;
  amount: number;
  properties?: any;
};

export default abstract class TrackingAdapter {
  abstract logEvent: (eventName: string, eventProperties?: any) => void;
  abstract revenue: (revenue: Revenue) => void;
  abstract setUser: (user: any) => void;
}
